
import NewChatV2 from './new-chat-v2.vue'
import NewChatV1 from './new-chat-v1.vue'
import $profile from 'stores/profile'

export default {
  components: {NewChatV2, NewChatV1},
  computed: {
    chat_2() {
      return $profile.chat_type === 'chat_v2'
    }
  }
}
